import * as React from "react";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import * as Lodash from "lodash";
import CameraGridTmdLapi from "@tunnel-components/@sharded/widgets/box/camera-tmd-lapi/component";
// import * as shortid from "shortid";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    itemsPerPage,
    currentPageNumbers,
    onUpdateCurrentPageNumber,
    itemPerRow,
    cameraListData,
    totalElements,
    grid,
  } = props;

  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */

  const rowRendererGrid = ({ index, key, style }: any): JSX.Element => {
    /**
     * @constant
     * @description :
     * @name  itemPerRowLine
     * @types number
     */
    const itemPerRowLine: number =
      !!cameraListData && cameraListData.length <= 3
        ? cameraListData.length
        : itemPerRow;
    /**
     * @constant
     * @description :
     * @name  items
     * @types any[]
     */
    const items: any[] = [];
    /**
     * @constant
     * @description :
     * @name  fromIndex
     * @types number
     */
    const fromIndex: number = index * itemPerRowLine;
    /**
     * @constant
     * @description :
     * @name  toIndex
     * @types number
     */
    const toIndex: number = Math.min(
      fromIndex + itemPerRowLine,
      cameraListData.length
    );

    {
      /** Boucle */
    }
    for (let i = fromIndex; i < toIndex; i++) {
      {
        /** Création du tableau des items */
      }

      items.push(
        <CameraGridTmdLapi
          key={i}
          item={!!cameraListData[i] && cameraListData[i]}
        />
      );
    }
    /**
     * Afffichage
     */
    return (
      <div
        key={key}
        style={{
          ...style,
          width: "100%",
        }}
      >
        {!Lodash.isUndefined(cameraListData[index]) &&
          !Lodash.isEmpty(cameraListData[index]) &&
          !!cameraListData[index] &&
          items}
      </div>
    );
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <VirtualPagination
      // key={shortid.generate()}
      classnames="incident-items" // la classe
      // cameraInactifs={!!Intervention}
      itemPerRow={
        grid
          ? !!cameraListData && cameraListData.length <= 3
            ? cameraListData.length
            : itemPerRow
          : 1
      }
      totalRowElements={cameraListData.length}
      widthView="100%" //
      heightView="100%" // hauteur et largeur de la fenètre
      rowHeight={400} // Hauteur de la cellule
      arrayContent={!Lodash.isEmpty(cameraListData)} // Boolean vérifie si le tableau est vide
      rowRenderer={rowRendererGrid} // élement JSX , column
      itemPerPage={itemsPerPage} // nombre d'élement par page
      totalItemLength={totalElements} // nombre total d'élement
      currentPageNumbers={currentPageNumbers} // la page courante
      onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // function de mise à jour de la page courante
    />
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  cameraListData?: any; // ok
  itemsPerPage?: any;
  currentPageNumbers?: any;
  onUpdateCurrentPageNumber?: any;
  itemPerRow?: any;
  totalElements?: any;
  grid?: boolean;
  rediRectToo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/camera-tmd-lapi/component.tsx